import { createSlice } from '@reduxjs/toolkit';

import { eventTypes, resourceTypes } from 'utils/schedulerConsts';
import { status } from 'utils/const';
import { selectors } from './selectors';
import { thunks } from './thunks';

const initialState = {
  getAppointmentsStatus: status.IDLE,
  latestAppointmentsRequestId: null,
  studentForPrivateCreate: null,
  classForGroupCreate: null,

  appointments: [],

  filters: {
    generalEventTypes: ['appointments'], // ['appointments', 'requests'],
    resourceType: resourceTypes.teacher,
    eventTypes: [eventTypes.private, eventTypes.group, eventTypes.internal],
    locations: [],
    teachers: [],
    students: [],
  },
};

const slice = createSlice({
  name: 'scheduler',
  initialState,
  reducers: {
    setGeneralEventType(state, action) {
      state.filters.generalEventTypes = action.payload;
    },
    setResourceType(state, action) {
      state.filters.resourceType = action.payload;
    },
    setEventType(state, action) {
      state.filters.eventTypes = action.payload;
    },
    setLocations(state, action) {
      state.filters.locations = action.payload;
    },
    setTeachers(state, action) {
      state.filters.teachers = action.payload;
    },
    setStudents(state, action) {
      state.filters.students = action.payload;
    },
    setStudentForPrivateCreate(state, action) {
      state.studentForPrivateCreate = action.payload;
    },
    setClassForGroupCreate(state, action) {
      state.classForGroupCreate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(thunks.getAppointments.pending, (state, action) => {
        state.getAppointmentsStatus = status.PENDING;
        state.latestAppointmentsRequestId = action.meta.requestId;
      })
      .addCase(thunks.getAppointments.rejected, (state, action) => {
        if (state.latestAppointmentsRequestId !== action.meta.requestId) return;

        state.getAppointmentsStatus = status.FAIL;
      })
      .addCase(thunks.getAppointments.fulfilled, (state, action) => {
        if (state.latestAppointmentsRequestId !== action.meta.requestId) return;

        const { data } = action.payload;

        state.getAppointmentsStatus = status.SUCCESS;
        state.appointments = data;
      });
  },
});

const scheduler = {
  actions: slice.actions,
  selectors,
  thunks,
};

export { scheduler };
export default slice.reducer;
